import { render } from "./ProspectsListItem.vue?vue&type=template&id=208c6b74"
import script from "./ProspectsListItem.vue?vue&type=script&lang=js"
export * from "./ProspectsListItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__